/**
 * Star Rating.jsx
 * Created by Destin Frasier on 8/3/17.
 * Modifieid by Mike Bray on 8/11/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from './icons/Icons';

const propTypes = {
    rating: PropTypes.number,
    voteCount: PropTypes.number
};

const defaultProps = {
    rating: 0,
    voteCount: 0
};

export default class StarRating extends React.Component {
    _generateStars() {
        let rating = this.props.rating;
        let key = 0;
        const stars = [];

        while (rating > 0 && stars.length < 5) {
            if (rating >= 1) {
                stars.push(<Icons.IconStar key={`star-rating-${key}`} />);
            }
            else {
                stars.push(<Icons.IconStarHalf key={`star-rating-${key}`} />);
            }

            rating -= 1;
            key += 1;
        }

        while (stars.length < 5) {
            stars.push(<Icons.IconStarBorder key={`star-rating-${key}`} />);
            key += 1;
        }

        return stars;
    }

    render() {
        const stars = this._generateStars();

        let sanitisedRating = this.props.rating < 0 ? 0 : this.props.rating;
        sanitisedRating = sanitisedRating > 5 ? 5 : sanitisedRating;

        let starText = 'stars';
        if (sanitisedRating === 1) {
            starText = 'star';
        }

        const voteCountText = (this.props.voteCount !== 1)
            ? `${this.props.voteCount} Reviews`
            : '1 Review';

        return (
            <div
                className="rec-star-rating"
                aria-label={`${sanitisedRating} ${starText}, ${voteCountText}`} >
                <div className="stars-container" aria-hidden="true">
                    {stars}
                </div>
                <span className="vote-count" aria-hidden="true">
                    {voteCountText}
                </span>
            </div>
        );
    }
}

StarRating.propTypes = propTypes;
StarRating.defaultProps = defaultProps;
